<template>
    <v-container fluid class="guest-courses py-0">
        <v-row align="center" justify="center">
            <v-col class="div-banner" cols="12" style="background-color: #008dd4; height: 15vh;">
                <v-img src="/images/neumann-logo-contorno.png"></v-img>
            </v-col>
            <v-col cols="12" lg="7" md="6" sm="12" xs="12">
                <v-alert v-if="stepper==3" border="top" color="red lighten-2" dark style="margin-top: -4vh" class="elevation-2 text-center">
                    <strong>{{ country_selected.alert }}</strong>
                </v-alert>
            </v-col>
        </v-row>

        <v-row align="center" justify="center" style="margin-top: -2vh">
            <v-col cols="12" lg="7" md="6" sm="12" xs="12">
                <v-stepper v-model="stepper">
                    <v-stepper-header>
                        <v-stepper-step step="1">Inicio</v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step step="2">Idioma</v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step step="3">Cursos</v-stepper-step>
                    </v-stepper-header>

                    <v-stepper-items>
                        <v-stepper-content step="1">
                            <v-card>
                                <v-card-title style="display: block !important" class="text-center">¿De que país nos visitas?.</v-card-title>
                                <v-card-text class="py-0">
                                    <p class="text-center">Es importante seleccionar tu país para que puedas ver los horarios de manera correcta.</p>
                                </v-card-text>
                                <v-card-text>
                                    <v-list>
                                        <v-list-item-group mandatory v-model="country_selected" active-class="blue--text text--darken-4">
                                            <template v-for="country in countries">
                                                <v-list-item :key="country.id" :value="country" @click="stepper = 2">
                                                    <template v-slot:default="{ active }">
                                                        <v-list-item-avatar size="60">
                                                            <v-img :src="country.url"></v-img>
                                                        </v-list-item-avatar>
                                                        <v-list-item-content>
                                                            <v-list-item-title>{{ country.text }}</v-list-item-title>
                                                        </v-list-item-content>
                                                    </template>
                                                </v-list-item>
                                            </template>
                                        </v-list-item-group>
                                    </v-list>
                                </v-card-text>
                                <v-divider></v-divider>
                                <v-card-actions>
                                    <v-btn block color="#008dd4" @click="stepper = 2" dark>¡Comencemos!</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-stepper-content>

                        <v-stepper-content step="2">
                            <v-card>
                                <v-card-title>Selecciona el idioma</v-card-title>
                                <v-card-text>
                                    <v-list>
                                        <v-list-item-group mandatory v-model="language_id" active-class="blue--text text--darken-4">
                                            <template v-for="language in languages">
                                                <v-list-item :key="language.id" :value="language.id" @click="stepper = 3">
                                                    <template v-slot:default="{ active }">
                                                        <v-list-item-avatar size="60">
                                                            <v-img :src="language_image_url+language.image"></v-img>
                                                        </v-list-item-avatar>
                                                        <v-list-item-content>
                                                            <v-list-item-title>{{ language.language }}</v-list-item-title>
                                                        </v-list-item-content>
                                                    </template>
                                                </v-list-item>
                                            </template>
                                        </v-list-item-group>
                                    </v-list>
                                </v-card-text>
                                <v-card-actions>
                                    <v-btn text color="#000" @click="() => { stepper = 1; skeleton_loading = true }">Atrás</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-stepper-content>

                        <v-stepper-content step="3">
                            <v-card>
                                <v-card-title>Selecciona tu curso</v-card-title>    
                                <v-card-text>
                                    <v-skeleton-loader type="card" :hidden="!skeleton_loading"></v-skeleton-loader>
                                    <template v-if="courses.length > 0">
                                        <v-card id="card-course" v-for="(course, index) in order_courses" :key="index" class="mb-3" outlined style="border-color: #008dd4; border-width: 4px;">
                                            <v-card-text class="py-0 px-0">
                                                <v-container class="py-0 px-0" fluid>
                                                    <v-row no-gutters>
                                                        <v-col id="title-hour" cols="12"  sm="12" xs="12" class="text-center align-center" style="background-color: #008dd4">
                                                            <v-container fill-height class="px-0">
                                                                <v-row>
                                                                    <v-col style="padding: 0px;">
                                                                        <h3 style="font-size: 1.5rem;" class="py-2 white--text">Hora : {{ course.country[country_selected.id].startTime }} - {{ course.country[country_selected.id].endTime }}</h3>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-container>
                                                        </v-col>
                                                        
                                                        <v-col class="px-2 py-2" cols="12"  sm="12" xs="12">
                                                            <v-list-item-title id="folio-course" ><strong>{{ course.name }}</strong></v-list-item-title>
                                                            <v-list-item-subtitle id="nivel-course" class="mt-4">Nivel : <strong>{{ course.level.name }}</strong></v-list-item-subtitle>
                                                            <v-list-item-subtitle id="available-course" class="mt-4" style="color: red;">Lugares disponibles : <strong>{{ course.spaces }}</strong> </v-list-item-subtitle>
                                                            <v-list-item-subtitle id="modality-course" class="mt-4" v-if="course.modality.id === 1">Días : <strong>Lunes, Miércoles y Viernes</strong> </v-list-item-subtitle>
                                                            <v-list-item-subtitle id="modality-course" class="mt-4" v-if="course.modality.id === 2">Días : <strong>Martes y Jueves</strong> </v-list-item-subtitle>
                                                            <v-list-item-subtitle id="modality-course" class="mt-4" v-if="course.modality.id === 3">Días : <strong>Sábados</strong> </v-list-item-subtitle>
                                                            <v-list-item-subtitle id="modality-course" class="mt-4" v-if="course.modality.id >= 4">Días : <strong>Lunes a viernes</strong> </v-list-item-subtitle>
                                                            <v-list-item-subtitle id="start-date-course" class="mt-4">Fecha tentativa de inicio : <strong>{{ course.date }}</strong> </v-list-item-subtitle>
                                                            <v-list-item-subtitle id="timezone-course" class="mt-4"><strong>{{ country_selected.timezone }}</strong> </v-list-item-subtitle>
                                                        </v-col>
                                                    </v-row>
                                                </v-container>
                                            </v-card-text>
                                            <v-divider></v-divider>
                                            <v-card-actions class="py-0 px-0">
                                                <v-btn style="background-color: #009688; color: white;" block text tile @click="redirect(course)"><strong>Seleccionar aquí tu curso</strong></v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </template>
                                    <v-card v-else outlined>
                                        <v-list>
                                            <v-list-item>
                                                <v-list-item-icon>
                                                    <v-icon x-large style="font-size: 4rem">mdi-emoticon-sad-outline</v-icon>
                                                </v-list-item-icon>
                                                <v-list-item-content>
                                                    <v-list-item-title>Sin cursos disponibles</v-list-item-title>
                                                    <v-list-item-subtitle>Lamentablemente no tenemos cursos disponibles.</v-list-item-subtitle>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list>
                                    </v-card>
                                </v-card-text>
                                <v-card-actions>
                                    <v-btn text color="#000" @click="() => { stepper = 2; skeleton_loading = true }">Atrás</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>
            </v-col>
        </v-row>
        <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
                <v-btn fixed bottom right fab class="mb-10" v-bind="attrs" v-on="on" x-large color="red lighten-2" dark @click="waiting_list = !waiting_list">
                    <v-icon>mdi-calendar-search</v-icon>
                </v-btn>
            </template>
            <span>¿Buscas otro horario?</span>
        </v-tooltip>

        <v-dialog v-model="waiting_list" max-width="800">
            <v-card>
                <v-card-title>Lista de espera</v-card-title>
                <v-card-text>
                    <v-card-subtitle class="py-0">Ingresa la información requerida y nosotros le notificaremos cuando nuevos cursos estén disponibles.</v-card-subtitle>
                    <v-container>
                        <v-row justify="center" align="center">
                            <v-col cols="12">
                                <v-form ref="waiting_list_form">
                                    <v-text-field v-model="waiting_list_item.name"  :rules="[rules.required]" filled label="Nombre(s)"></v-text-field>
                                    <v-text-field v-model="waiting_list_item.email" :rules="[rules.required, rules.email]" filled @keydown.space.prevent label="Correo electrónico"></v-text-field>
                                    <v-text-field v-model="waiting_list_item.start_time" type="time" filled label="Hora de inicio (24 hrs)"></v-text-field>
                                    <v-select v-model="waiting_list_item.level_id"  :rules="[rules.required]" :items="levels_a" item-text="name" item-value="id" label="Nivel buscado" filled></v-select>
                                </v-form>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="waiting_list = false">cancelar</v-btn>
                    <v-btn color="primary" @click="waiting_list_register">REGISTRARME</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>

import iziToast from 'izitoast'
const meses = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre']

export default {
    props:['languages','levels','levels_a'],
    data: () => ({
        modality:"",
        tabs:"",
        courses_url:"/courses-available",
        language_image_url:"/storage/langs_disk/",
        initial_avatar:"https://ui-avatars.com/api/?name=",
        final_avatar:"&background=random",
        modalities:[
            { modality_id: 1, text: 'Lunes, Miércoles y Viernes' },
            { modality_id: 2, text: 'Martes y Jueves' },
            { modality_id: 3, text: 'Sábados' }
        ],
        courses: [],
        overlay:true,
        stepper:1,
        language_id:"",
        age:3,
        modality_id:"",
        level_id:"",
        skeleton_loading:false,
        rules:{
            required: v => !!v || 'El campo es requerido',
            email: v => /^[^@]+@[^@]+\.[a-zA-Z]{2,}$/.test(v) || 'El Correo electrónico ingresado no es válido'
        },
        waiting_list:false,

        waiting_list_item:{
            name:"",
            email:"",
            level_id:"",
            start_time:"",
        },
        countries: [
            {
                text: "México",
                url: "/images/mexico.png",
                id: 1,
                code: 'MX',
                alert: "Los horarios están registrados utilizando la zona horaria estándar de la capital Ciudad de México (GMT-6)",
                timezone: "Hora estándar del centro de México(GMT-6)"
            },
            {
                text: "Argentina",
                url: "/images/argentina.png",
                id: 2,
                code: 'AR',
                alert: "Los horarios están registrados utilizando la zona horaria estándar de la capital Buenos Aires(GMT-3)",
                timezone: "Hora estándar de la capital Buenos Aires(GMT-3)"
            },
            {
                text: "Chile",
                url: "/images/chile.png",
                id: 3,
                code: 'CL',
                alert: "Los horarios están registrados utilizando la zona horaria estándar de la capital Santiago(GMT-4)",
                timezone: "Hora estándar de la capital Santiago(GMT-4)"
            },
            {
                text: "Perú",
                url: "/images/peru.png",
                id: 4,
                code: 'PE',
                alert: "Los horarios están registrados utilizando la zona horaria estándar de la capital Lima(GMT-5)",
                timezone: "Hora estándar de la capital Lima(GMT-5)"
            },
            {
                text: "Colombia",
                url: "/images/colombia.png",
                id: 5,
                code: 'CO',
                alert: "Los horarios están registrados utilizando la zona horaria estándar de la capital Bogotá(GMT-5)",
                timezone: "Hora estándar de la capital Bogotá(GMT-5)"
            },
            {
                text: "Uruguay",
                url: "/images/uruguay.png",
                id: 6,
                code: 'UY',
                alert: "Los horarios están registrados utilizando la zona horaria estándar de la capital Montevideo(GMT-3)",
                timezone: "Hora estándar de la capital Montevideo(GMT-3)"
            },
        ]
    }),

    watch:{
        stepper:function(val){
            val === 3 ? this.getCourses() : ''
        }
    },

    computed:{
        order_courses:function(){
            let order_courses = []
            for(let course of this.courses){
                course.date = course.start_date.split('-').reverse()
                course.date[1] = meses[parseInt(course.date[1])-1]
                course.date = course.date.join('/')
                course.spaces = course.student_limit - course.number_students <= course.rm_students ? course.student_limit - course.number_students : course.rm_students
                order_courses.push(course)
            }

            return order_courses
        },
    },

    methods:{
        getCourses: function(){
            let data = {}
            let modalities = []
            data.language_id = this.language_id

            if(this.age == 1) modalities.push(4);
            if(this.age == 2) modalities.push(5);

            if(this.age > 2){
                modalities = []
                modalities.push(1,2,3)
            }

            data.modalities = modalities

            axios.get(this.courses_url, { params: data }).then(response => {
                this.courses = response.data.courses
                this.skeleton_loading = false
                
                this.courses.forEach(course => {
                    let startTime = new Date(`${course.start_date}T${course.schedule[0].start_time}:00-06:00`);
                    let endTime = new Date(`${course.start_date}T${course.schedule[0].end_time}:00-06:00`);
                    course.country = []
                    course.country[1] = {
                        startTime: startTime.toLocaleString("en-US", {timeZone: "America/Mexico_City", hour12: false}).split(", ")[1].trim().slice(0, -3),
                        endTime: endTime.toLocaleString("en-US", {timeZone: "America/Mexico_City", hour12: false}).split(", ")[1].trim().slice(0, -3)
                    }
                    course.country[2] = {
                        startTime: startTime.toLocaleString("en-US", {timeZone: "America/Argentina/Buenos_Aires", hour12: false}).split(", ")[1].trim().slice(0, -3),
                        endTime: endTime.toLocaleString("en-US", {timeZone: "America/Argentina/Buenos_Aires", hour12: false}).split(", ")[1].trim().slice(0, -3)
                    }
                    course.country[3] = {
                        startTime: startTime.toLocaleString("en-US", {timeZone: "America/Santiago", hour12: false}).split(", ")[1].trim().slice(0, -3),
                        endTime: endTime.toLocaleString("en-US", {timeZone: "America/Santiago", hour12: false}).split(", ")[1].trim().slice(0, -3)
                    }
                    course.country[4] = {
                        startTime: startTime.toLocaleString("en-US", {timeZone: "America/Lima", hour12: false}).split(", ")[1].trim().slice(0, -3),
                        endTime: endTime.toLocaleString("en-US", {timeZone: "America/Lima", hour12: false}).split(", ")[1].trim().slice(0, -3)
                    }
                    course.country[5] = {
                        startTime: startTime.toLocaleString("en-US", {timeZone: "America/Bogota", hour12: false}).split(", ")[1].trim().slice(0, -3),
                        endTime: endTime.toLocaleString("en-US", {timeZone: "America/Bogota", hour12: false}).split(", ")[1].trim().slice(0, -3)
                    }
                    course.country[6] = {
                        startTime: startTime.toLocaleString("en-US", {timeZone: "America/Montevideo", hour12: false}).split(", ")[1].trim().slice(0, -3),
                        endTime: endTime.toLocaleString("en-US", {timeZone: "America/Montevideo", hour12: false}).split(", ")[1].trim().slice(0, -3)
                    }
                });
                console.log(this.courses)
            }).catch(error => { console.log(error) });
        },

        redirect:function(course){
            window.location = '/register?course_id='+course.folio;
        },

        waiting_list_register:function(){
            if(this.$refs.waiting_list_form.validate()){
                let data = {}
                data.name       = this.waiting_list_item.name
                data.email      = this.waiting_list_item.email
                data.level_id   = this.waiting_list_item.level_id
                data.start_time = this.waiting_list_item.start_time


                axios.post("/waiting_list/store", data).then(response => {
                    this.waiting_list = false
                    iziToast.success({
                        title:"Correcto",
                        message:"Registrado a lista de espera correctamente",
                        position:"topRight"
                    })
                    this.$refs.waiting_list_form.reset()
                }).catch(error => {
                    this.$refs.waiting_list = false
                    this.$refs.waiting_list_form.reset()

                    console.log(error)
                })
                
            }
        }
    }
}
</script>
<style>

/* En línea #11 | http://localhost:8000/courses-available */

#card-course {
  font-size: 1rem;
  margin-top: 5px !important;
}


#nivel-course {
  font-size: 1rem;
  margin-top: 5px !important;
}

#available-course {
  font-size: 1rem;
  margin-top: 5px !important;
}

#modality-course {
  font-size: 1rem;
  margin-top: 5px !important;
}

#start-date-course {
  font-size: 1rem;
  margin-top: 5px !important;
}

#timezone-course {
  font-size: 1rem;
  margin-top: 5px !important;
}

#folio-course {
  font-size: 1rem;
  margin-top: 5px !important;
}
#title-hour > .col{
    padding: 0px;
}

</style>